import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State } from '@progress/kendo-data-query';
import { DatePipe } from '@angular/common';
import { CRMService } from '../../services/crm.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    Contact
    , CustomerParentHistory
    , CustomerStatus
    , SearchCustomer
    , VolumeRange
} from '../../models/models';

@Component({
    selector: 'customer-detail',
    templateUrl: './customer-detail.component.html',
    standalone: false
})
export class CustomerDetail implements OnInit {
    public isShowLeadStatusType: boolean = false;
    public customerCode: string = '';
    public customerName: string = '';
    public customer: SearchCustomer = {} as SearchCustomer;
    public customerParentHistory: CustomerParentHistory[] = [];
    public billToList: CustomerParentHistory[] = [];
    public stopsList: CustomerParentHistory[] = [];
    public quotesList: CustomerParentHistory[] = [];
    public contacts: Contact[] = [];
    public customerStatusList: CustomerStatus[] = [];
    public customerStatus: CustomerStatus = {} as CustomerStatus;
    public volumeRanges: VolumeRange[] = [];
    public billToView: GridDataResult = { data: [], total: 0 };
    public stopsView: GridDataResult = { data: [], total: 0 };
    public quotesView: GridDataResult = { data: [], total: 0 };
    public billToState: State = { skip: 0, take: 10 };
    public stopsState: State = { skip: 0, take: 10 };
    public quotesState: State = { skip: 0, take: 10 };
    public currentDate: Date = new Date();
    public includeParent: boolean = false;
    public monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    public tagsRefreshDate: Date = new Date();

    public divFlags = {
        'customerForm': false
    };

    constructor(private route: ActivatedRoute, private titleService: Title,
        private crmService: CRMService, private notificationService: NotificationService, private orderService: OrderService,
        private utilService: UtilService, public datePipe: DatePipe) {
        route.params.subscribe(params => { this.customerCode = params.customerCode });
        titleService.setTitle('Customer Profile - ' + this.customerCode);
    }

    ngOnInit() {
        this.searchCustomer();
        this.getCustomerStatuses();
        this.getVolumeRanges();
    }

    public toggleFlag(div: string) {
        this.divFlags[div] = !this.divFlags[div];
    }

    public searchCustomer() {
        if (this.customerCode.length > 0) {
            this.crmService.getSearchCustomerByCustomerCode(this.customerCode).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.customer = result.resultCollection[0];
                    this.getContacts();
                    //this.getCustomerHistory();
                }
            });
        }
    }

    private getCustomerStatuses() {
        this.crmService.getCustomerStatuses().subscribe(result => {
            this.customerStatusList = result;
        });
    }

    private getVolumeRanges() {
        this.crmService.getVolumeRanges().subscribe(result => {
            this.volumeRanges = result;
        });
    }

    private getContacts() {
        this.crmService.getContactsByCustomerCode(this.customer.customerCode).subscribe(result => {
            this.contacts = result;
        });
    }

    public getCustomerHistory() {
        this.utilService.isLoading = true;
        this.crmService.getHistoryByCustomerId(this.customer.customerID, this.includeParent).subscribe(result => {
            this.utilService.isLoading = false;
            this.customerParentHistory = result.resultCollection;
            this.setBillToGrid();
            this.setStopsGrid();
            this.setQuotesGrid();
        });
    }

    public onTabSelect(evt: any) {
        console.log("onTabSelect", evt);
    }

    private setBillToGrid() {
        this.billToList = this.customerParentHistory.filter(t => t.customerHistoryType == "BillTo");
        if (this.billToState.sort) {
            this.billToList = orderBy(this.billToList, this.billToState.sort);
        }
        this.billToView = process(this.billToList, this.billToState);
    }

    public billToStateChange(state: DataStateChangeEvent) {
        this.billToState = state;
        this.setBillToGrid();
    }

    private setStopsGrid() {
        this.stopsList = this.customerParentHistory.filter(t => t.customerHistoryType == "Stops");
        if (this.stopsState.sort) {
            this.stopsList = orderBy(this.stopsList, this.stopsState.sort);
        }
        this.stopsView = process(this.stopsList, this.stopsState);
    }

    public stopsStateChange(state: DataStateChangeEvent) {
        this.stopsState = state;
        this.setStopsGrid();
    }

    private setQuotesGrid() {
        this.quotesList = this.customerParentHistory.filter(t => t.customerHistoryType == "Quotes");
        if (this.quotesState.sort) {
            this.quotesList = orderBy(this.quotesList, this.quotesState.sort);
        }
        this.quotesView = process(this.quotesList, this.quotesState);
    }

    public quotesStateChange(state: DataStateChangeEvent) {
        this.quotesState = state;
        this.setQuotesGrid();
    }

    public getContactNameById(id: number): string {
        if (id < 1) return '';

        var contact = this.contacts.find(c => c.contactID == id) as Contact;

        return contact.fullName;
    }

    public getCustomerStatusDisplay() {
        var status = this.customerStatusList.find(s => s.customerStatusId == this.customer.customerStatusID);
        var display = "";

        if (status != null) {
            this.customerStatus = status;
            display = this.customerStatus.description;
        }
        else {
            this.customerStatus = {} as CustomerStatus;
        }

        return display;
    }

    public customerSaved(evt: any) {
        this.divFlags['customerForm'] = false;
        this.searchCustomer();
    }

    public refreshData(evt: any) {
        if (evt == "tags") {
            this.tagsRefreshDate = new Date();
        }
    }
}
